import React from 'react';
import { Textarea as ChakraTextarea } from '@chakra-ui/react';

// eslint-disable-next-line no-unused-vars
const Textarea = React.forwardRef((props, ref) => {
  return <ChakraTextarea size="sm" ref={ref} {...props} />;
});

export default Textarea;
